import { IExtractedField } from 'types/db/ExtractedProForma';
import { OperationsMetricId } from '../../layout/metrics';
import { BlockResolver } from '../../layout/types';
import {
    buildFieldMap, derivedCell, extractedCell,
} from './cells';
import {
    cashFlowFromOperations, netOperatingIncome, percentOfTotalProjectCost, valuation, valuationPerUnit,
} from './formulas';

export const extractedOperationsResolver = (fields: IExtractedField[]): BlockResolver<OperationsMetricId> => {
    const fieldMap = buildFieldMap(fields);

    return {

        'effectiveGrossRevenue.untrended': extractedCell(fieldMap, 'operations.effective_gross_revenue'),
        'effectiveGrossRevenue.trended': extractedCell(fieldMap, 'operations.effective_gross_revenue_trended'),
        'effectiveGrossRevenue.sale': extractedCell(fieldMap, 'operations.effective_gross_revenue_at_sale'),

        'operatingExpenses.untrended': extractedCell(fieldMap, 'operations.operating_expenses'),
        'operatingExpenses.trended': extractedCell(fieldMap, 'operations.operating_expenses_trended'),
        'operatingExpenses.sale': extractedCell(fieldMap, 'operations.operating_expenses_at_sale'),

        'netOperatingIncome.untrended': extractedCell(fieldMap, 'operations.net_operating_income'),
        'netOperatingIncome.trended': derivedCell(() => netOperatingIncome(fieldMap, '_trended'), 'currency'),
        'netOperatingIncome.sale': derivedCell(() => netOperatingIncome(fieldMap, '_at_sale'), 'currency'),

        'capitalExpenditures.untrended': extractedCell(fieldMap, 'operations.capital_expenditures'),
        'capitalExpenditures.trended': extractedCell(fieldMap, 'operations.capital_expenditures_trended'),
        'capitalExpenditures.sale': extractedCell(fieldMap, 'operations.capital_expenditures_at_sale'),

        'cashFlowFromOperations.untrended': extractedCell(fieldMap, 'operations.cash_flow_from_operations'),
        'cashFlowFromOperations.trended': derivedCell(() => cashFlowFromOperations(fieldMap, '_trended'), 'currency'),
        'cashFlowFromOperations.sale': derivedCell(() => cashFlowFromOperations(fieldMap, '_at_sale'), 'currency'),

        'capRate.untrended': extractedCell(fieldMap, 'operations.cap_rate'),
        'capRate.trended': extractedCell(fieldMap, 'operations.cap_rate_trended'),
        'capRate.sale': extractedCell(fieldMap, 'operations.cap_rate_at_sale'),

        'valuation.untrended': extractedCell(fieldMap, 'operations.valuation'),
        'valuation.trended': derivedCell(() => valuation(fieldMap, '_trended'), 'currency'),
        'valuation.sale': extractedCell(fieldMap, 'operations.valuation_at_sale'),

        'percentOfTotalProjectCost.untrended': extractedCell(fieldMap, 'operations.percent_of_total_project_cost'),
        'percentOfTotalProjectCost.trended': derivedCell(() => percentOfTotalProjectCost(fieldMap, '_trended'), 'percentage'),
        'percentOfTotalProjectCost.sale': derivedCell(() => percentOfTotalProjectCost(fieldMap, '_at_sale'), 'percentage'),

        'valuationPerUnit.untrended': extractedCell(fieldMap, 'operations.valuation_per_unit'),
        'valuationPerUnit.trended': derivedCell(() => valuationPerUnit(fieldMap, '_trended'), 'currency'),
        'valuationPerUnit.sale': derivedCell(() => valuationPerUnit(fieldMap, '_at_sale'), 'currency'),
    };
};
